// extracted by mini-css-extract-plugin
export default {"border":"ImagNewPicker_border__6gO9f","flx":"ImagNewPicker_flx__ucGbw","text":"ImagNewPicker_text__6+-20","end":"ImagNewPicker_end__W1zdu","imge3":"ImagNewPicker_imge3__uXaV+"};